import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M328 180c25.7 0 55.9 16.9 59.9 42.1 1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0l-9.5 8.5c-8.3 7.4-21.6 0.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM353.6 304.6c10-3.1 19.4 5.5 17.7 15.3-7.9 47.1-71.3 80-123.3 80s-115.3-32.9-123.3-80c-1.7-10 7.8-18.5 17.7-15.3 25.9 8.3 64.4 13.1 105.5 13.1s79.6-4.8 105.5-13.1zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-wink.js
// module id = 1759
// module chunks = 0